import * as PIXI from 'pixi.js';
import { IAnimationDependencies, IAnimation } from 'js/bubbleCore/view/animations/types';
import { fillAnimationDependencies } from 'js/bubbleCore/view/animations/fillAnimationDependencies';

export function createSplashAnimation(
  texture: string | PIXI.Texture,
  dependencies: Partial<IAnimationDependencies> = {},
): IAnimation<PIXI.Sprite> {
  const { spritePool, tweenMgr, rnd } = fillAnimationDependencies(dependencies);

  const root = spritePool.getInstance().props({
    alpha: 0.5,
    anchor: {x: 0.5, y: 0.74},
    scale: 0,
    texture,
  });

  const scale = rnd.realInRange(0.9, 1.1);
  const duration = rnd.between(280, 320);

  tweenMgr.create(root.scale)
    .to({x: scale, y: scale}, duration, tweenMgr.easing.Cubic.Out, true);
  const alphaTween = tweenMgr.create(root)
    .to({alpha: 0}, 150, tweenMgr.easing.Sinusoidal.Out, true, duration - 150)

  alphaTween.onComplete.add(() => spritePool.release(root));

  return {
    root,
    onCompleteAsync: alphaTween.asyncOnComplete(),
    cancel: () => {},
  }
}